import api from './api';


export const courseService = {

  getCourses: async () => {
    const response = await api.get('/courses');
    return response.data;
  },


  getCourseById: async (courseId) => {
    const response = await api.get(`/courses/${courseId}`);
    return response.data;
  },


  getCourseModules: async (courseId) => {
    const response = await api.get(`/courses/${courseId}/modules`);
    return response.data;
  },

 
  getModuleLessons: async (courseId, moduleId) => {
    const response = await api.get(`/courses/${courseId}/modules/${moduleId}/lessons`);
    return response.data;
  },

  getCourseLessonsSummary: async (courseId) => {
    const response = await api.get(`/courses/${courseId}/lessons-summary`);
    return response.data;
  },


  getLessonDetails: async (courseId, moduleId, lessonId) => {
    const response = await api.get(`/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`);
    return response.data;
  },

 
  getLessonById: async (lessonId) => {
    const response = await api.get(`/lessons/${lessonId}`);
    return response.data;
  },


  getCourseStructure: async (courseId) => {
    const response = await api.get(`/courses/${courseId}/structure`);
    return response.data;
  },


  getModuleWithLessons: async (moduleId) => {
    const response = await api.get(`/modules/${moduleId}/lessons`);
    return response.data;
  },
};

